/* src/components/utils/getBreadcrumbFromSidebar.js - Última MOdificación: 28-12-2025 */
/* ---------------------------------------------------------------------------------- */

import { sidebarMenu } from "../../config/sidebarMenu.js";

export const getBreadcrumbFromSidebar = (pathname) => {
  const cleanPath = pathname.replace(/^\/+/, "").toLowerCase();

  let level1 = null;
  let level2 = null;
  let itemFound = null;

  // 1️⃣ Buscar item
  for (const menu of sidebarMenu) {
    for (const item of menu.items) {
      const itemPath = item.link.replace(/^\/+/, "").toLowerCase();

      if (cleanPath === itemPath) {
        itemFound = {
          label: item.name,
          link: item.link,
        };

        if (menu.level === 1) {
          level1 = menu;
        }

        if (menu.level === 2) {
          level2 = menu;
          // buscar su padre (nivel 1 con mismo group)
          level1 = sidebarMenu.find(
            (m) => m.level === 1 && m.group === menu.group
          );
        }

        break;
      }
    }
    if (itemFound) break;
  }

  // 2️⃣ Si no existe en sidebar → Home / genérico
  if (!itemFound) {
    return {
      trail: [
        {
          label: "Inicio",
          link: "/home",
        },
      ],
    };
  }

  // 3️⃣ Construir trail
  const trail = [];

  if (level1) {
    trail.push({
      label: level1.title,
    });
  }

  if (level2) {
    trail.push({
      label: level2.title,
    });
  }

  trail.push(itemFound);

  return { trail };
};
